export default __webpack_public_path__ + "static/media/smrtm.abf16d77.svg";